export const CLICK = 'CLICK'
export const TRAFFIC_LANDING_PAGE_VIEW = 'TRAFFIC_LANDING_PAGE_VIEW'
export const ENGAGED_VIEW = 'ENGAGED_VIEW'
export const ENGAGED_VIEW_FIFTEEN = 'ENGAGED_VIEW_FIFTEEN'
export const FOLLOWERS = 'FOLLOWERS'
export const PROFILE_VIEWS = 'PROFILE_VIEWS'
export const CONVERT = 'CONVERT'
